'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFreeProduct = exports.hasFreeProduct = undefined;

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _intersectionOfObjects = require('./intersectionOfObjects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FREE_PRODUCTS = [_MerchandiseIds.PRODUCT_CRM, _MerchandiseIds.PRODUCT_MARKETING_FREE, _MerchandiseIds.PRODUCT_SALES_FREE, _MerchandiseIds.PRODUCT_SERVICE_FREE];

// We need to check parcels for free products to know
// whether or not they have been activated since we can't
// rely on the new products endpoint for this info.
var hasFreeProduct = exports.hasFreeProduct = function hasFreeProduct(userParcels, merchandiseId) {
  var parcels = _ImmutableMerchandiseIdMap2.default[merchandiseId].parcels;
  var parcelsOwned = userParcels.map(function (parcel) {
    return {
      parcelName: parcel.parcelName,
      parcelVersion: parcel.parcelVersion && parcel.parcelVersion.version
    };
  });

  return (0, _intersectionOfObjects.intersectionOfObjects)(parcels, parcelsOwned).length > 0;
};

var isFreeProduct = exports.isFreeProduct = function isFreeProduct(merchandiseId) {
  return FREE_PRODUCTS.indexOf(merchandiseId) !== -1;
};


//////////////////
// WEBPACK FOOTER
// ./js/utils/freeProductUtils.js
// module id = 355
// module chunks = 3 4 5